import { Layout } from "./layout";

export type Props = {
	children: React.ReactNode;
};

export const FeatureIslandLayout = ({ children }: Props) => {
	return (
		<Layout className="rounded-lg border border-zinc-100 bg-white p-4 sm:p-6 lg:p-12">
			<Layout className="space-y-6">{children}</Layout>
		</Layout>
	);
};
